/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 6
// module chunks = main